import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";

import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import DashboardPage from "@/pages/DashboardPage";
import StudioPage from "@/pages/StudioPage";
import BrandKitsPage from "@/pages/BrandKitsPage";
import GalleryPage from "@/pages/GalleryPage";
import BillingPage from "@/pages/BillingPage";
import SettingsPage from "@/pages/SettingsPage";
import AdminPage from "@/pages/AdminPage";
import TeamsPage from "@/pages/TeamsPage";
import BatchPage from "@/pages/BatchPage";
import ABTestingPage from "@/pages/ABTestingPage";
import DistributePage from "@/pages/DistributePage";
import AppLayout from "@/components/AppLayout";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#08080A] flex items-center justify-center"><div className="w-8 h-8 border-2 border-[#CDFE65] border-t-transparent rounded-full animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><AppLayout><DashboardPage /></AppLayout></ProtectedRoute>} />
      <Route path="/studio" element={<ProtectedRoute><AppLayout><StudioPage /></AppLayout></ProtectedRoute>} />
      <Route path="/brand-kits" element={<ProtectedRoute><AppLayout><BrandKitsPage /></AppLayout></ProtectedRoute>} />
      <Route path="/gallery" element={<ProtectedRoute><AppLayout><GalleryPage /></AppLayout></ProtectedRoute>} />
      <Route path="/billing" element={<ProtectedRoute><AppLayout><BillingPage /></AppLayout></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><AppLayout><SettingsPage /></AppLayout></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AppLayout><AdminPage /></AppLayout></ProtectedRoute>} />
      <Route path="/teams" element={<ProtectedRoute><AppLayout><TeamsPage /></AppLayout></ProtectedRoute>} />
      <Route path="/batch" element={<ProtectedRoute><AppLayout><BatchPage /></AppLayout></ProtectedRoute>} />
      <Route path="/ab-testing" element={<ProtectedRoute><AppLayout><ABTestingPage /></AppLayout></ProtectedRoute>} />
      <Route path="/distribute" element={<ProtectedRoute><AppLayout><DistributePage /></AppLayout></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App dark">
          <AppRoutes />
          <Toaster position="top-right" theme="dark" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
